import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import RIEBase from 'components/core/editable/RIEBase';
import { css } from 'emotion';

const labelStyle = css`
    font-weight:normal;
    margin-bottom:0;
    white-space:nowrap;
    cursor: pointer;
`;

/**
 * Modified from https://github.com/kaivi/riek, v1.1.0
 */
export default class RIERadioGroup extends RIEBase {

    static propTypes = {
        options: PropTypes.object, //value/label pairs
        radioGroupName: PropTypes.string, //required if there are multiple radio groups on the page
        normalComponentTextOnly: PropTypes.bool //in normal read only view only display text, no radio buttons for cleaner view in table
    };

    static defaultProps = {
        normalComponentTextOnly: false
    };

    radioClick = (event) => {
        const newValue = event.target.value;
        this.setState({ newValue });
    };

    elementBlur = (e) => {
        const componentArea = ReactDOM.findDOMNode(this.refs.container);

        //explicitOriginalTarget for firefox/safari on mac
        const clickedElement = e.relatedTarget || e.nativeEvent.explicitOriginalTarget || document.activeElement;
        if (!componentArea.contains(clickedElement)) {
            this.finishEditing();
        }

        //fix for firefox/safari on mac
        // I think this has been resolved?
        /*if (e.nativeEvent.explicitOriginalTarget) {
            console.log('test');
            setTimeout(() => {
                componentArea.focus();
            }, 0);
        }*/
    };

    renderOptions = () => {
        const radios = [];
        const groupName = this.props.radioGroupName || 'radios';

        Object.keys(this.props.options).forEach(value => {
            const isValue = this.getNewValue() === value;
            radios.push(
                <Flexbox key={value} flexDirection={'row'}>
                    <label className={labelStyle}>
                        <input
                            type="radio"
                            name={groupName}
                            ref="input"
                            value={value}
                            checked={isValue}
                            tabIndex="1"
                            onChange={this.radioClick}
                            className={css`margin-right:2px;`}
                            disabled={this.props.isDisabled}
                        />
                        {this.props.options[value]}
                    </label>
                </Flexbox>
            );
        });

        return radios;
    };

    renderReadComponent = () => {
        const value = this.getNewValue();

        if (this.props.normalComponentTextOnly) {
            // add onFocus back in order to go into edit mode via tab key then refactor RIE base so context menu will still work
            // onFocus={this.startEditing}
            return (
                <span
                    className={this.makeClassString()}
                    {...this.getStartEditingProps()}
                    {...this.props.defaultProps}
                >
                    {this.props.options[value]}
                </span>
            );
        } else {
            return this.renderNormalComponent();
        }
    };

    renderNormalComponent = () => {
        return (
            <div
                className={`rie-radio ${this.makeClassString()}`}
                {...this.getStartEditingProps()}
                {...this.props.editProps}
            >
                {this.renderOptions()}
            </div>
        );
    };

    renderEditingComponent = () => {
        return (
            <div
                className={`radio-wrapper rie-radio ${this.makeClassString()} ${css`padding: 8px 3px !important;`}`}
                {...this.props.editProps}
            >
                {this.renderOptions()}
            </div>
        );
    };

}



// WEBPACK FOOTER //
// ./src/components/core/editable/RIERadioGroup.js